"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestProgressionToJSON = exports.QuestProgressionFromJSONTyped = exports.QuestProgressionFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function QuestProgressionFromJSON(json) {
    return QuestProgressionFromJSONTyped(json, false);
}
exports.QuestProgressionFromJSON = QuestProgressionFromJSON;
function QuestProgressionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'isComplete': json['isComplete'],
        'claimedAt': !(0, runtime_1.exists)(json, 'claimedAt') ? undefined : json['claimedAt'],
        'lastStatReset': !(0, runtime_1.exists)(json, 'lastStatReset') ? undefined : json['lastStatReset'],
        'questConfigId': !(0, runtime_1.exists)(json, 'questConfigId') ? undefined : json['questConfigId'],
        'pointsReset': !(0, runtime_1.exists)(json, 'pointsReset') ? undefined : json['pointsReset'],
        'pointsTotal': !(0, runtime_1.exists)(json, 'pointsTotal') ? undefined : json['pointsTotal'],
        'progression': ((0, runtime_1.mapValues)(json['progression'], _1.QuestProgressionMilestoneFromJSON)),
        'prerequisites': json['prerequisites'],
    };
}
exports.QuestProgressionFromJSONTyped = QuestProgressionFromJSONTyped;
function QuestProgressionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'userId': value.userId,
        'isComplete': value.isComplete,
        'claimedAt': value.claimedAt,
        'lastStatReset': value.lastStatReset,
        'questConfigId': value.questConfigId,
        'pointsReset': value.pointsReset,
        'pointsTotal': value.pointsTotal,
        'progression': ((0, runtime_1.mapValues)(value.progression, _1.QuestProgressionMilestoneToJSON)),
        'prerequisites': value.prerequisites,
    };
}
exports.QuestProgressionToJSON = QuestProgressionToJSON;
